import apiClient from "QueryClient/axiosClient";

export const registerNewUserViaGoogle = (data) => {
  return apiClient.post("/auth/registerWithGoogleLogin", data);
};

export const loginUserWithGoogleToken = (data) => {
  return apiClient.post("/auth/loginWithGoogle", data);
};

export const logoutUser = () => {
  return apiClient.post("/auth/logout");
};
